module.exports = __webpack_public_path__ + "static/media/designspecs.90226039.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/design-specifications/assets/designspecs.svg
// module id = 73
// module chunks = 0